import { render, staticRenderFns } from "./wangEditQu.vue?vue&type=template&id=63169da4&scoped=true&"
import script from "./wangEditQu.vue?vue&type=script&lang=js&"
export * from "./wangEditQu.vue?vue&type=script&lang=js&"
import style0 from "./wangEditQu.vue?vue&type=style&index=0&id=63169da4&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63169da4",
  null
  
)

export default component.exports